import { Mention } from '@tiptap/extension-mention';
import { Placeholder } from '@tiptap/extension-placeholder';
import { generateText } from '@tiptap/core';
import { generateHTML, generateJSON } from '@tiptap/react';
import { StarterKit } from '@tiptap/starter-kit';
import { TiptapDoc } from './tiptap-types';

const extensions = [
  StarterKit,
  Mention.configure({
    HTMLAttributes: { class: 'mention' },
    renderHTML({ options, node }) {
      return [
        'span',
        { ...options.HTMLAttributes, 'data-id': node.attrs.id },
        `@${(node.attrs.label as string | undefined) ?? '…'}`,
      ];
    },
  }),
  Placeholder,
];

export const tiptapDocToHtml = (doc: TiptapDoc): string => generateHTML(doc, extensions);

export const htmlToTiptapDoc = (html: string): TiptapDoc => generateJSON(html, extensions) as TiptapDoc;

export const tiptapContentToPlainText = (content: string): string => {
  if (content.trimStart().startsWith('<')) {
    return content.replace(/<[^>]*>/g, '').trim();
  }
  try {
    const doc = JSON.parse(content) as TiptapDoc;
    return generateText(doc, extensions, {
      textSerializers: {
        mention: ({ node }: { node: { attrs?: Record<string, unknown> } }) => {
          const label = node.attrs?.label as string | undefined;
          const id = node.attrs?.id as string | undefined;
          return `@${label ?? id ?? ''}`;
        },
      },
    });
  } catch {
    return content;
  }
};
